<form (ngSubmit)="save()" #resumeForm="ngForm">
  <div class="row">
    <div class="col-12">
      <div class="box">
        <h2>Contact Information</h2>
        <div class="row mt-2">
          <div class="col-sm-4">
            <div class="form-group">
              <label for="firstName" class="required">First Name</label>
              <input #firstName="ngModel" id="firstName" name="firstName" mdbInput mdbValidate type="text" required
                     class="form-control" [(ngModel)]="application.firstName" />
              <mdb-error *ngIf="firstName.invalid && (firstName.dirty || firstName.touched)">First Name is required.</mdb-error>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label for="lastName" class="required">Last Name</label>
              <input #lastName="ngModel" id="lastName" name="lastName" mdbInput mdbValidate type="text" required
                     class="form-control" [(ngModel)]="application.lastName" />
              <mdb-error *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)">Last Name is required.</mdb-error>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label for="emailAddress" class="required">Email Address</label>
              <input #emailAddress="ngModel" id="emailAddress" name="emailAddress" mdbInput mdbValidate type="text"
                     required [pattern]="emailRegex"
                     class="form-control" [(ngModel)]="application.emailAddress" />
              <mdb-error *ngIf="emailAddress.invalid && (emailAddress.dirty || emailAddress.touched)">Valid email address required.</mdb-error>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-12">
      <div class="box">
        <h2>Resume</h2>
        <div class="formBody pt-3">
          <div class="file-field form-group" [class.uploading]="uploadingResume">
            <button type="button" mdbBtn class="btn-outline" [class.btn-invalid]="resumeInvalid" [class.valid]="uploadedResume && !resumeInvalid" mdbWavesEffect
                    (click)="resumeFileInput.click()">
              <span *ngIf="!uploadedResume && !resumeInvalid"><i class="fa fa-spinner fa-spin"></i>Upload Resume</span>
              <span *ngIf="uploadedResume && !resumeInvalid"><i class="fa fa-check-circle"></i> {{resumeName}}</span>
              <span *ngIf="resumeInvalid && !resumeFileIsEmpty"><i class="fa fa-close"></i> Unsupported File Type or Size</span>
              <span *ngIf="resumeInvalid && resumeFileIsEmpty"><i class="fa fa-close"></i> File cannot be Empty</span>
            </button>
            <a href="javascript:void(0);" *ngIf="(resumeName && uploadedResume) || resumeInvalid" class="removeResume" (click)="removeResume()">Remove</a>
            <input [hidden]="true" #resumeFileInput type="file" accept=".doc,.docx,.pdf,.rtf,.txt" (change)="uploadResume($event)" (click)="openResumeControl($event)">
            <input type="hidden" name="fileValue" [required]="model.isResumeRequired" [(ngModel)]="resumeName" />
          </div>
          <span *ngIf="model.isResumeRequired" class="text-danger file-field-required">*</span>
          <span *ngIf="!model.isResumeRequired" class="file-field-optional">(Optional)</span>
          <div class="col-12 removeResumeContainer">
            <p>
              <span>Acceptable: DOC, DOCX, PDF, RTF or TXT file types (5 MB max)</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-3" *ngIf="model.isCoverLetterIncluded">
    <div class="col-12">
      <div class="box">
        <h2>Cover Letter</h2>
        <div class="formBody pt-3">
          <div class="file-field form-group" [class.uploading]="uploadingCoverLetter">
            <button type="button" mdbBtn class="btn-outline" [class.btn-invalid]="coverLetterInvalid" [class.valid]="uploadedCoverLetter && !coverLetterInvalid" mdbWavesEffect
                    (click)="coverLetterFileInput.click()">
              <span *ngIf="!uploadedCoverLetter && !coverLetterInvalid"><i class="fa fa-spinner fa-spin"></i>Upload Cover Letter</span>
              <span *ngIf="uploadedCoverLetter && !coverLetterInvalid"><i class="fa fa-check-circle"></i> {{coverLetterName}}</span>
              <span *ngIf="coverLetterInvalid && !coverLetterFileIsEmpty"><i class="fa fa-close"></i> Unsupported File Type or Size</span>
              <span *ngIf="coverLetterInvalid && coverLetterFileIsEmpty"><i class="fa fa-close"></i> File cannot be Empty</span>
            </button>
            <input [hidden]="true" #coverLetterFileInput type="file" accept=".doc,.docx,.pdf,.rtf,.txt" (change)="uploadCoverLetter($event)" (click)="ensureCanReplaceSameDocument($event)">
            <input type="hidden" name="coverLetterValue" [required]="model.isCoverLetterRequired" [(ngModel)]="coverLetterName" />
            <a href="javascript:void(0);" *ngIf="(coverLetterName && uploadedCoverLetter) || coverLetterInvalid" class="removeResume" (click)="removeCoverLetter()">Remove</a>
          </div>
          <span *ngIf="model.isCoverLetterRequired" class="text-danger file-field-required">*</span>
          <span *ngIf="!model.isCoverLetterRequired" class="file-field-optional">(Optional)</span>

          <p><span>Acceptable: DOC, DOCX, PDF, RTF or TXT file types (5 MB max)</span></p>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-2">
    <div class="col-12 text-right">
      <button class="btn btn-primary mx-0 mt-1" mdbWavesEffect (click)="save()" [disabled]="!resumeForm.form.valid || resumeInvalid || coverLetterInvalid || processingServerSideRequest">
        <i class="fa fa-spinner fa-spin" aria-hidden="true" *ngIf="processingServerSideRequest"></i> Save and continue
      </button>
    </div>
  </div>
</form>


<div mdbModal #areYouSureModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
     aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="areYouSureModal.hide()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel">Are you sure?</h4>
      </div>
      <div class="modal-body">Uploading a new resume will overwrite information already added to this job application. Are you sure you want to upload a new resume?</div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" aria-label="No" (click)="areYouSureModal.hide()" mdbWavesEffect>No</button>
        <button type="button" class="btn btn-primary" aria-label="Yes" (click)="openUploadResumeControl()" mdbWavesEffect>Yes</button>
      </div>
    </div>
  </div>
</div>

